import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgMetaMask = function SvgMetaMask(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 121"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#E2761B",
        stroke: "#E2761B",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M107.421 12.031 66.594 42.354l7.55-17.89z"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#E4761B",
        stroke: "#E4761B",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m13.17 12.031 40.499 30.61-7.18-18.177zM92.732 82.32 81.858 98.98l23.265 6.4 6.688-22.69zm-83.87.37 6.647 22.69 23.265-6.4-10.873-16.66z"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#E4761B",
        stroke: "#E4761B",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m37.461 54.171-6.483 9.807 23.101 1.026-.82-24.825zm45.669 0L67.127 39.892l-.533 25.112 23.06-1.026zM38.774 98.978l13.869-6.77-11.981-9.355zm29.174-6.77 13.91 6.77-1.929-16.125z"
    })), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
        fill: "#D7C1B3",
        stroke: "#D7C1B3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m81.858 98.978-13.91-6.77 1.108 9.068-.123 3.816zm-43.084 0 12.925 6.114-.082-3.816 1.026-9.068z"
    })), _path5 || (_path5 = /*#__PURE__*/ React.createElement("path", {
        fill: "#233447",
        stroke: "#233447",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m51.905 76.862-11.571-3.406 8.165-3.734zm16.782 0 3.405-7.14 8.207 3.734z"
    })), _path6 || (_path6 = /*#__PURE__*/ React.createElement("path", {
        fill: "#CD6116",
        stroke: "#CD6116",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m38.774 98.978 1.97-16.659-12.844.37zM79.888 82.32l1.97 16.66 10.873-16.29zm9.766-18.341-23.06 1.026 2.133 11.858 3.406-7.14 8.207 3.734zm-49.32 9.478 8.206-3.734 3.364 7.14 2.175-11.858-23.101-1.026z"
    })), _path7 || (_path7 = /*#__PURE__*/ React.createElement("path", {
        fill: "#E4751F",
        stroke: "#E4751F",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m30.978 63.978 9.684 18.875-.329-9.397zm49.362 9.478-.41 9.397 9.724-18.875zm-26.26-8.452-2.176 11.858 2.708 13.992.616-18.423zm12.514 0-1.108 7.385.492 18.465 2.75-13.992z"
    })), _path8 || (_path8 = /*#__PURE__*/ React.createElement("path", {
        fill: "#F6851B",
        stroke: "#F6851B",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m68.728 76.862-2.75 13.992 1.97 1.354 11.982-9.355.41-9.397zm-28.394-3.406.328 9.397 11.981 9.355 1.97-1.354-2.708-13.992z"
    })), _path9 || (_path9 = /*#__PURE__*/ React.createElement("path", {
        fill: "#C0AD9E",
        stroke: "#C0AD9E",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m68.933 105.092.123-3.816-1.026-.903H52.56l-.943.903.082 3.816-12.925-6.114 4.514 3.693 9.15 6.36h15.715l9.191-6.36 4.514-3.693z"
    })), _path0 || (_path0 = /*#__PURE__*/ React.createElement("path", {
        fill: "#161616",
        stroke: "#161616",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m67.948 92.208-1.97-1.354H54.613l-1.97 1.354-1.026 9.068.944-.903H68.03l1.026.903z"
    })), _path1 || (_path1 = /*#__PURE__*/ React.createElement("path", {
        fill: "#763D16",
        stroke: "#763D16",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m109.144 44.324 3.488-16.742-5.211-15.55-39.473 29.296L83.13 54.171l21.46 6.278 4.759-5.54-2.051-1.476 3.282-2.996-2.544-1.97 3.283-2.502zM8 27.582l3.488 16.742-2.216 1.64 3.283 2.504-2.503 1.97 3.282 2.995-2.051 1.477L16 60.45l21.46-6.279 15.182-12.843L13.17 12.031z"
    })), _path10 || (_path10 = /*#__PURE__*/ React.createElement("path", {
        fill: "#F6851B",
        stroke: "#F6851B",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M104.59 60.45 83.13 54.17l6.524 9.807-9.724 18.875 12.801-.164h19.08zM37.461 54.17l-21.46 6.278-7.14 22.24h19.04l12.76.164-9.683-18.875zm29.133 10.833 1.354-23.676 6.237-16.864H46.488l6.155 16.864 1.436 23.676.493 7.468.04 18.382H65.98l.082-18.382z"
    })));
};

export { SvgMetaMask as ReactComponent };
//# sourceMappingURL=MetaMask.svg.es.js.map
